import { Routes } from '@angular/router';
import { paymentRulesRedirect } from '../../../../shared/payment-rules/payment-rules-redirects';
import { residentRedirect } from '../../../../shared/benefits-page/benefits-redirects';

export const DESKTOP_MENU_ROUTES: Routes = [
  // Хаб и CMS-страницы льгот заменены страницей about-benefits (UIMSP-1450).
  {
    path: 'children/benefits-and-resident-membership',
    pathMatch: 'full',
    redirectTo: '/desktop/main/about-benefits',
  },
  {
    path: 'page/categories-of-citizens-eligible-for-benefits',
    pathMatch: 'full',
    redirectTo: '/desktop/main/about-benefits',
  },
  {
    path: 'page/online-application-submission',
    pathMatch: 'full',
    redirectTo: '/desktop/main/about-benefits',
  },
  { path: 'page/resident-abonement', pathMatch: 'full', redirectTo: residentRedirect('desktop') },
  // Способы оплаты и штрафы заменены страницей payment-rules (прототип 1a).
  {
    path: 'children/payment-method',
    pathMatch: 'full',
    redirectTo: '/desktop/main/payment-rules',
  },
  {
    path: 'page/payment-using-a-mobile-app',
    pathMatch: 'full',
    redirectTo: paymentRulesRedirect('desktop', 'app'),
  },
  {
    path: 'page/payment-via-payment-terminals',
    pathMatch: 'full',
    redirectTo: paymentRulesRedirect('desktop', 'terminal'),
  },
  { path: 'page/fines', pathMatch: 'full', redirectTo: paymentRulesRedirect('desktop', 'fines') },
  {
    path: 'page/:slug',
    loadComponent: () => import('./pages').then(c => c.MenuPageComponent),
  },
  {
    path: 'children/:slug',
    loadComponent: () => import('./pages').then(c => c.MenuChildrenComponent),
  },
];
